import React, { FC, memo } from 'react';
import classnames from 'classnames';

import { useFeatureFlagsContext } from 'application/providers/FeatureFlagsProvider';
import { useModalContext } from 'application/providers/ModalProvider';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';

import { TEXTS } from './texts';
import useOfertaButtonViewModel from './useOfertaButtonViewModel';

import styles from './index.module.scss';

interface OfertaButtonProps {
  className?: string;
  containerClassName?: string;
}

const OfertaButton: FC<OfertaButtonProps> = ({ className, containerClassName }) => {
  const { isOffertaChanged } = useFeatureFlagsContext();
  const { isDesktop } = useMedia();
  const { openModal, closeModal } = useModalContext();

  const { hasActiveOfferta, ofertaOnClick, isOffertaChangeModalAvailable } = useOfertaButtonViewModel({
    isOffertaChanged,
    openModal,
    closeModal,
  });

  return (
    <div className={classnames(styles.buttonContainer, containerClassName)}>
      {hasActiveOfferta && (
        <Button
          key="total_price_block_show_oferta"
          elementId="company_page_button_show_oferta"
          className={classnames(styles.ofertaButton, className)}
          type={ButtonType.PLAIN}
          onClick={ofertaOnClick}>
          {isOffertaChangeModalAvailable && <div className={styles.notice} />}
          {isDesktop ? TEXTS.SHOW_OFERTA : TEXTS.OFERTA}
        </Button>
      )}
    </div>
  );
};

export default memo(OfertaButton);
